import Image from "next/image";

export const Logo = (props: React.ComponentProps<"div">) => (
  <div className="relative" {...props}>
    <Image
      src="/logo-stack-flow-blanc.png"
      alt="Stack Flow Logo"
      width={140}
      height={45}
      className="object-contain w-full h-auto"
      priority
    />
  </div>
);
